import { Status } from '../enums/status';
import { BaseModel } from './base.model';
import { DocumentType } from './document-type';

export class Document extends BaseModel {
  userId: string = '';
  documentType: DocumentType = new DocumentType();
  downloadUrl: string = '';
  countryOfIssue: string = '';
  documentOption?: string;
  expiryDate?: Date;
  idNumber?: string;
  status: Status = Status.PENDING;

  constructor(data?: Partial<DocumentType>) {
    super();
    Object.assign(this, data);
  }
}
